<script lang="tsx">
import { defineComponent, toRef, type PropType } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { FormItem } from '-/Common/Form'
import { InputRmb } from '-/Common/Input'
import { getRequiredRule } from '@/constant/form'
const [name] = createNamespace('TicketTownResettleStandardForm')

export default defineComponent({
  name,
  props: {
    dataSync: {
      type: Object as PropType<Partial<ApiJtProj.ResettleStandardData>>
    }
  },
  setup(props) {
    const data = toRef(props, 'dataSync', {})
    return () => (
      <div class='ant-row-form-item'>
        安置总价款
        <FormItem name='fangPiaoAnZhiXiangZhen' rules={getRequiredRule('安置总价款')}>
          <InputRmb v-model:value={data.value.fangPiaoAnZhiXiangZhen} style='width: 150px' addonAfter='元/人' />
        </FormItem>
      </div>
    )
  }
})
</script>
